// extracted by mini-css-extract-plugin
export default {"logoutBtn":"logout-component_logoutBtn__R4DtB","logoutLogo":"logout-component_logoutLogo__Kcvoz","logoutText":"logout-component_logoutText__xcS+h"};